export const LOAN_OFFER_SCREENS = {
    LOADER: "LOADER",
    NEXT_STEP: "NEXT_STEP",
    LOAN_OFFERS: "LOAN_OFFERS",
    ERROR_SCREEN: "ERROR_SCREEN"
};
